<template>
	<div class="bodyDemo">
		<!-- <div style="background-color: rgba(0,0,0,0.5);right: 0;bottom: 0;left: 0;top: 0;z-index: 9999; position: fixed;">
					<div>
						<img src="../static/llq.png"
							style="width: 50px;height: 50px;position: absolute;left: 10px;top: 10px;" />
						<div style="color: #FFFFFF;position: absolute;left: 10px;top: 60px;">点击返回，重新认证</div>
					</div>
				</div> -->
		<div class="resultBox2" v-if="dialogVisible">
			<video id="testVideo" ref="testVideo" webkit-playsinline autoplay width="300" height="300">
				<source :src="videoDataURL" />
			</video>
			<div class="btn2" @click="dialogVisible = false">返回</div>
		</div>
		<div class="resultBox" v-if="restartVisible">
			<div v-if="pass">
				<img src="@/static/renzhengtongguo.png" style="width: 90px; margin-bottom: 20px" />
				<h3 class="firstTipsH">认证通过</h3>
				<p class="firstTipsP" style="padding-bottom: 20px">
					恭喜您，完成了人脸检测
				</p>
				<!-- <img :src="image" width="300" height="400"/>-->
				<div class="btn2" @click="getBack" style="background-color: #a5a8b3;" v-if="degradationScheme == 3">
					返回{{ numbers }}秒后自动返回
				</div>
				<div class="btn2" @click="dialogVisible = true" v-else>查看视频</div>
			</div>
			<div v-else class="passFail">
				<img src="@/static/renzhengshibai.png" style="width: 120px; margin-bottom: 20px" />
				<h3 class="firstTipsH" style="color: red">{{ tip }}</h3>
				<p class="firstTipsP" style="padding-bottom: 20px">
					认证未通过，请重新检测
				</p>
				<div class="btn2" @click="getBack">返回</div>
			</div>
		</div>
		<div v-if="isSupported" class="Demo">
			<div v-if="!isSupported">浏览器不支持webrtc的API</div>
			<div :class="['tip', { running: colorRunning }]">{{ tip }}</div>
			<div class="center">
				<div class="ui-camera">
					<div id="videoParent" class="ui-camera-inner">
						<div class="videoParentIn" v-if="iscover"></div>
						<div class="videoParentIn2" v-if="iscover"></div>
						<video id="face-live-detection-video" :muted="true" :playsinline="true" :autoplay="true">
							Please update your browser.
						</video>
					</div>
				</div>
			</div>
			<div v-if="currentColorIdx === 0" :class="['circle', 'circle1']"
				:style="{ backgroundColor: currentColorValue }" />
			<div v-if="currentColorIdx === 1" :class="['circle', 'circle2']"
				:style="{ backgroundColor: currentColorValue }" />
			<div v-if="currentColorIdx === 2" :class="['circle', 'circle3']"
				:style="{ backgroundColor: currentColorValue }" />
		</div>
		<div v-else class="jiangji">
			<div v-if="degradationScheme != 3">
				<h2>当前浏览器不支持webrtc的API，已转为降级方案</h2>
				<br />
				<div>
					请依次执行动作：<br />1.眨眨眼、<br />2.张张嘴、<br />3.向左转头，<br />每个动作缓慢执行<br />录制视频时间控制在5秒内
				</div>
				<br />
				<button type="button" class="btn" @click="startRecord">开始录制</button>
				<input ref="recordingVideoInput" type="file" name="video" accept="video/*" capture="user" id="pop_video"
					style="display: none" @change="changeVideo" />
			</div>
			<div v-else>
				<div class="downgrade-text">请拍摄一张正脸图片</div>
				<div class="downgrade-guide-wrapper">
					<img :src="require('@/static/imageGuideCorrect.png')" alt=""
						class="downgrade-guide-correct-image" />
					<div class="downgrade-guide-sub-wrapper">
						<img :src="require('@/static/imageGuideBright.png')" alt="" class="downgrade-guide-sub-image" />
						<img :src="require('@/static/imageGuideDark.png')" alt="" class="downgrade-guide-sub-image" />
					</div>
				</div>
				<div class="downgrade-tip-wrapper">
					<div class="downgrade-tip">光线充足，避免过爆或过暗</div>
					<div class="downgrade-tip">面部清晰完整</div>
				</div>
				<el-button type="button" @click="startRecordImg">开始拍摄</el-button>
				<input ref="recordingImgInput" type="file" name="image" accept="image/*" capture="user"
					style="display: none" @change="changeImage" />
			</div>
		</div>
	</div>
</template>
<script>
import $http from '@/utils/http'
import { Loading } from 'element-ui'
import cdplivedetection from '@chinadatapay/live-detection'
// import VConsole from 'vconsole';
// 只有在开发环境下才加载vconsole
// process.env.NODE_ENV === 'development' && new VConsole();

const CODE = '12345'

function getRandom(arr, n) {
	const result = new Array(n)
	let len = arr.length
	const taken = new Array(len)
	if (n > len) {
		throw new RangeError('getRandom: more elements taken than available')
	}
	while (n--) {
		let x = Math.floor(Math.random() * len)
		result[n] = arr[x in taken ? taken[x] : x]
		taken[x] = --len in taken ? taken[len] : len
	}
	return result
}
function getParameter(name) {
	var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
	var r = window.location.search.substr(1).match(reg)
	if (r != null) {
		return decodeURI(r[2])
	} else {
		return null
	}
}
let actionCode = ''

export default {
	name: 'act9901',
	data() {
		return {
			timer: null,
			numbers: 5,
			iscover: 1,
			pass: 0,
			tip: '请平视并正对屏幕',
			code: CODE.split(''),
			currentColorIdx: -1,
			currentColorValue: 'transparent',
			actionIndex: 0,
			actionTotal: 1,
			loading: false,
			cdplivedetection: cdplivedetection,
			videoDataURL: '',
			option: {
				solutionType: 2,
				livenessThreshold: 0.9,
			},
			form: {
				name: '',
				type: 0,
				idcard: '',
				back: 0,
			},
			degradationScheme: 3, //2降级视频  3降级图片
			spoofing: 0.00048,
			image: '',
			dialogVisible: false,
			restartVisible: false,
			token: '',
			apiUrl: 'api',
			isSupported: cdplivedetection.isSupport(),
			backImg: '',
			backNo: '',
			names: '',
			idcards: '',
			isapp: 'h5'
		}

	},
	computed: {
		colorRunning() {
			return this.currentColorIdx !== -1
		},
	},
	// 改动点： 在页面 mounted 的时候进行初始化
	mounted() {
		var _t = this
		const token = getParameter('token')
		const apiUrl = getParameter('apiUrl') || 'api' //调用机房设置
		_t.token = token
		_t.apiUrl = apiUrl
		_t.names = getParameter('name')
		_t.idcards = getParameter('idcard')
		_t.isapp = getParameter('isapp') ? getParameter('isapp') : 'h5'
		var browserName = cdplivedetection.UA().getResult().browser.name
		console.log(browserName)
		if (browserName == 'Quark') {
			_t.degradationScheme = 2 //夸克浏览器兼容问题仅支持降级视频模式
		}
		if (_t.$route.query.type) {
			_t.form.type = _t.$route.query.type
		}
		_t.form.name = _t.$route.query.name
		_t.form.idcard = _t.$route.query.idcard
		_t.form.back = _t.$route.query.back
		_t.form.scoreThreshold = _t.$route.query.scoreThreshold
		_t.$nextTick(() => {
			if (!_t.token) {
				_t.tip = '请先获取token'
				_t.restartVisible = true
				_t.pass = false
				return false
			} else {
				_t.init()
			}
		})

	},
	methods: {
		times() {
			if (this.timer) {
				clearInterval(this.timer);
			}
			this.timer = setInterval(() => {
				if (this.numbers > 0) {
					this.numbers = this.numbers - 1;
				} else {
					clearInterval(this.timer);
					// 倒计时结束的操作
					if (this.isapp == 'h5') {
						window.history.go(-1)

					} else if (this.isapp == 'wx') {
						wx.miniProgram.navigateBack({
							delta: 1, // 返回的页面数
							success: () => {
								console.log("返回上一页成功");
							},
							fail: (err) => {
								console.error("返回失败", err);
							}
						});
					} else if (this.isapp == 'app') {
						uni.webView.navigateBack({
							delta: 1 // 返回上两级页面
						});
					}
				}
			}, 1000);
		},
		//返回表单页
		getBack() {
			if (this.backNo) {
				return false
			}
			if (this.isapp == 'h5') {
				window.history.go(-1)

			} else if (this.isapp == 'wx') {
				wx.miniProgram.navigateBack({
					delta: 1, // 返回的页面数
					success: () => {
						console.log("返回上一页成功");
					},
					fail: (err) => {
						console.error("返回失败", err);
					}
				});
			} else if (this.isapp == 'app') {
				uni.webView.navigateBack({
					delta: 1 // 返回上两级页面
				});
			}
			// var _t = this
			// _t.$router.push({ path: 'http://www.baidu.com'})
			// var newForm = {
			// 	name: _t.form.name,
			// 	type: _t.form.type,
			// 	idcard: _t.form.idcard,
			// 	token: _t.token,
			// 	apiUrl: _t.apiUrl,
			// 	scoreThreshold: _t.form.scoreThreshold,
			// 	back: 1,
			// }
			// _t.$router.push({ path: '/9901', query: newForm }) //path路径为自己表单页路由
		},
		// 改动点，新增的 init 方法，在mounted时候进行调用
		init() {
			this.cdplivedetection = new cdplivedetection({
				video: 'face-live-detection-video', //  对应html 中id为video的dom元素id
				solutionType: +this.option.solutionType, //  活体⽅案类型：     0 -静默检测；  1 -动作检测；  2 -炫瞳检测
				code: actionCode, // 0-眨眼；1-张嘴；2-向右转头；3-向左转头；4-向上抬头；5-向下低头
				randomMotionDetection: false, // 是否随机动作，开启后会随机指定⼀个动作，如果不是随机的可以通过code属性进⾏灵活配置
				needToRecord: true, // 是否开启录制功能
				minFaceRatio: 0.2,
				maxFaceRatio: 0.8,
				constraints: {
					video: {
						width: {
							min: 320,
							ideal: 320,
							max: 320,
						},
						height: {
							min: 240,
							ideal: 240,
							max: 240,
						},
					},
					audio: false,
				},
				isOriginImage: true,
				autoloadModels: false,
				modelPath: 'https://myoss.chinadatapay.com:29000/cdp',
				authUrl:
					'https://api.chinadatapay.com/token/getJssdkAuthToken?token=' +
					this.token,
				token: '',
				videoDataURL: '',
			})
			this.bindEvents()
			// 降级模式下不需要加载模型
			if (this.isSupported) {
				this.start().then(() => this.cdplivedetection.loadModels())
			}
		},
		beforeDestroy() {
			//不能删，模型用到
			this.cdplivedetection.destroy()
		},
		bindEvents() {
			this.cdplivedetection.on('status', (status) => {
				console.log('status', status)
				if (status === 'loading_over') {
					this.loading = false
				}
			})
			this.cdplivedetection.on('tip', (a) => {
				if (!a.text) {
					this.tip = '请平视并正对屏幕'
				} else {
					this.tip = a.text
				}
			})
			this.cdplivedetection.on(
				'color',
				(currentColorIdx, currentColorValue) => {
					this.currentColorIdx = currentColorIdx
					this.currentColorValue = currentColorValue
				}
			)
			this.cdplivedetection.on('action', (val) => {
				this.actionIndex = val
			})
			this.cdplivedetection.on('success', (result) => {
				this.tip = '检测完成,请保持不动等待返回'
				this.videoDataURL = URL.createObjectURL(result.video)
				this.images = result.images
				const image = result.images[0].src.substring(
					result.images[0].src.indexOf(',') + 1
				)
				this.fetchFaceLiveness(image, result.video)
			})
			this.cdplivedetection.on('fail', (type) => {
				if (type === 'timeout') {
					this.tip = '检测超时'
					this.pass = false
					this.restartVisible = true
				} else if (type === 'unsupported') {
					this.tip = '该浏览器不支持'
					this.pass = false
					this.restartVisible = true
				} else if (type === 'reject') {
					this.tip = '获取相机权限失败'
					this.pass = false
					this.restartVisible = true
				} else if (type === 'auth') {
					this.tip = '认证不通过'
					this.pass = false
					this.restartVisible = true
				} else if (type === 'pdFail') {
					this.tip = '炫瞳检测失败'
					this.pass = false
					this.restartVisible = true
				} else if (type === 'action_timeout') {
					this.pass = false
					this.restartVisible = true
					this.tip = '动作检测超时'
				}
				this.restartVisible = true
			})
			// 2022.07.01 改动点，新增摄像头开启事件
			this.cdplivedetection.on('camera_open', () => {
				console.log('摄像头已开启')
				this.tip = '请平视并正对屏幕'
				this.iscover = 0
			})
		},
		async start() {
			// 开始验证，此时会唤起摄像头。并在id为face-live-detection-video的标签内插⼊video标签。
			// 注：该⽅法只会在⾸次验证的时候调⽤，后续需要⽤restart⽅法
			await this.cdplivedetection.start()
		},
		// 改动点
		async restart() {
			//this.actionIndex = 0;
			this.destroy()
			this.tip = '请平视并正对屏幕'
			// 当动作超时或者采集流程超时，需要重新发起认证，这时候⽤restart⽅法
			// 与start⽅法的不同之处在于不会重新执⾏插⼊video和⼀些初始化操作
			this.cdplivedetection.restart()
		},
		//销毁
		destroy() {
			this.actionIndex = 0
			// 销毁验证流程，建议在组件卸载时调⽤
			this.cdplivedetection.destroy()
		},
		//降级图片模式
		startRecordImg() {
			this.$refs.recordingImgInput.click()
		},
		// 降级图片
		async changeImage(e) {
			let file = e.target.files[0]
			//压缩后上传
			this.checkAndHandleCompression(file).then((fileOptions) => {
				this.fetchFaceLiveness(fileOptions.uploadFile, 0)
			})
		},
		getBase64(file) {
			return new Promise(function (resolve, reject) {
				const reader = new FileReader()
				let imgResult = ''
				reader.readAsDataURL(file)
				reader.onload = function () {
					imgResult = reader.result
				}
				reader.onerror = function (error) {
					reject(error)
				}
				reader.onloadend = function () {
					resolve(imgResult)
				}
			})
		},

		//降级视频模式
		changeVideo(ev) {
			var _t = this
			var loadingInstance = Loading.service({ fullscreen: true })
			let filesIds = document.getElementById('pop_video')
			var filesId = filesIds.files[0]
			_t.videoDataURL = URL.createObjectURL(filesId) //视频
			_t.getBase64(filesId).then((res) => {
				var sentD2 = {
					res: res,
					filesId: filesId,
					mytoken: _t.token,
					threshold: _t.option.livenessThreshold + '',
					apiUrl: _t.apiUrl,
				}
				cdplivedetection.videoLiveness(
					_t.form,
					sentD2,
					function (backImg, backNo, backCode, backMsg, backResult) {
						if (backCode == '10000') {
							if (backResult == 1) {
								//通知后端成功了
								//返回查询页
								//查询页请求后端接口实名是否成功
								_t.pass = true
								_t.restartVisible = true
							} else {
								_t.pass = false
								_t.tip = backMsg
								_t.restartVisible = true
							}
						} else {
							_t.tip = backMsg
							_t.restartVisible = true
							_t.pass = false
						}
						loadingInstance.close()
					}
				)
			})
		},
		startRecord() {
			this.$refs.recordingVideoInput.click()
		},
		setAxios(backImg, backNo, backResult) {
			$http.post('/verify/notify_cdp_result', {
				seqNo: backNo,
				token: this.token,
				backImg: backImg,
				result: backResult,
				name: this.names,
				id_card: this.idcards
			}).then(response => {
				// 处理响应数据
				console.log('response', response);
			}).catch(error => {
				// 处理错误情况
				console.log('error', error);
			});
		},
		/**
		 * 人获取图片活体检测结果接口
		 */
		fetchFaceLiveness(images, vedio) {
			var loadingInstance = Loading.service({ fullscreen: true })
			var _t = this
			var sentD2 = {
				images: images,
				vedio: vedio,
				mytoken: _t.token,
				threshold: _t.option.livenessThreshold + '',
				apiUrl: _t.apiUrl,
			}
			_t.cdplivedetection.imgLiveness(
				_t.form,
				sentD2,
				function (
					backImg,
					backNo,
					backCode,
					backMsg,
					backResult,
					backVideo,
					serialNumber,
					backScore
				) {
					if (backCode == '10000') {
						console.log(backCode, "成功", backImg,
							backNo,
							backCode,
							backMsg,
							backResult,
							backVideo,
							serialNumber,
							backScore)
						_t.image = images
						if (backResult == 1) {
							_t.backImg = backImg
							_t.backNo = backNo
							_t.setAxios(backImg, backNo, backResult)
							_t.times()
							_t.pass = true
							_t.restartVisible = true
						} else {
							_t.pass = false
							_t.tip = backMsg
							_t.restartVisible = true
						}
					} else {
						_t.tip = backMsg
						_t.restartVisible = true
						_t.pass = false
					}
					loadingInstance.close()
				}
			)
		},
		/**
		 * 检查并压缩图片大小
		 */
		checkAndHandleCompression(file) {
			var _t = this
			return new Promise((resolve, reject) => {
				_t.imgBase64(file, (image, canvas) => {
					let maxSize = 500 //500kb (单位KB)
					let fileSize = file.size / 1024 // 图片大小 (单位KB)

					let uploadSrc, uploadFile
					if (fileSize > maxSize) {
						// 如果图片大小大于maxSize，进行压缩
						uploadSrc = canvas.toDataURL(file.type, maxSize / fileSize)
						uploadFile = _t.convertBase64UrlToFile(uploadSrc, file.name) // 转成file文件
					} else {
						uploadSrc = image.src
						uploadFile = file
					}
					let fileOptions = { uploadSrc, uploadFile }
					resolve(fileOptions)
				})
			})
		},

		/**
		 * 将图片转化为base64
		 */
		imgBase64(file, callback) {
			// 看支持不支持FileReader
			if (!file || !window.FileReader) return
			// 创建一个 Image 对象
			let image = new Image()
			// 绑定 load 事件处理器，加载完成后执行
			image.onload = function () {
				// 创建 canvas DOM 对象
				let canvas = document.createElement('canvas')
				// 返回一个用于在画布上绘图的环境, '2d' 指定了您想要在画布上绘制的类型
				let ctx = canvas.getContext('2d')
				// 如果高度超标 // 参数，最大高度
				let MAX_HEIGHT = 1200
				if (image.height > MAX_HEIGHT) {
					// 宽度等比例缩放 *=
					image.width *= MAX_HEIGHT / image.height
					image.height = MAX_HEIGHT
				}
				// 获取 canvas的 2d 环境对象,
				// 可以理解Context是管理员，canvas是房子
				ctx.clearRect(0, 0, canvas.width, canvas.height)
				// 重置canvas宽高
				canvas.width = image.width
				canvas.height = image.height
				// 将图像绘制到canvas上
				ctx.drawImage(image, 0, 0, image.width, image.height)
				callback(image, canvas)
			}
			if (/^image/.test(file.type)) {
				// 创建一个reader
				let reader = new FileReader()
				// 将图片将转成 base64 格式
				reader.readAsDataURL(file)
				// 读取成功后的回调
				reader.onload = function () {
					// 设置src属性，浏览器会自动加载。
					// 记住必须先绑定事件，才能设置src属性，否则会出同步问题。
					image.src = this.result
				}
			}
		},

		/**
		 * 把Base64转换成file文件
		 */
		convertBase64UrlToFile(dataurl, filename) {
			let arr = dataurl.split(','),
				mime = arr[0].match(/:(.*?);/)[1],
				bstr = atob(arr[1]),
				n = bstr.length,
				u8arr = new Uint8Array(n)
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n)
			}
			return new File([u8arr], filename, { type: mime })
		},
	},
}
</script>
<style scoped>
.bodyDemo {
	max-width: 500px;
	width: 100%;
	position: relative;
	margin: 0 auto;
}

.tips p {
	line-height: 30px;
}

.jiangji {
	padding: 50px 20px;
}

.Demo {
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
	padding-top: 60px;
	position: relative;
}

.resultBox {
	position: absolute;
	z-index: 999;
	width: 90%;
	left: 5%;
	min-height: 70vh;
	padding-top: 30%;
	background: #fff;
	text-align: center;
}

.resultBox2 {
	position: absolute;
	z-index: 1000;
	width: 90%;
	left: 5%;
	height: 100%;
	background: #fff;
	text-align: center;
}

#testVideo {
	margin-top: 30%;
}

.firstTipsH {
	font-size: 26px;
}

.firstTipsP {
	color: #a5a8ac;
}

.passFail {
	color: red;
}

.passFail label {
	margin-left: 10px;
}

.passFail>div:first-child {
	margin: 0 auto;
	overflow: auto;
	display: flex;
	text-align: center;
	justify-content: center;
}

.btn {
	clear: both;
	margin: 20px auto;
	cursor: pointer;
	background: #333333;
	padding: 10px 20px;
	border-radius: 10px;
	color: #fff;
}

.btn2 {
	clear: both;
	margin: 20px auto;
	cursor: pointer;
	background: #1576ff;
	padding: 10px 20px;
	border-radius: 10px;
	color: #fff;
}

#videoParent {
	position: relative;
	width: 300px;
	height: 300px;
	border-radius: 50%;
	overflow: hidden;
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 0 auto;
	background-color: #fff;
	border: 1px solid #ddd;
	/* -webkit-mask-image: -webkit-radial-gradient(white, black);*/
}

.videoParentIn {
	position: absolute;
	width: 300px;
	height: 300px;
	border-radius: 50%;
	background: linear-gradient(#fff, #fff, #fff, #1576ff);
	animation: bgc 1.5s infinite linear;
	z-index: 22;
}

.videoParentIn2 {
	position: absolute;
	top: 2px;
	left: 2px;
	z-index: 23;
	width: 296px;
	height: 296px;
	border-radius: 50%;
	background: #fff;
}

@keyframes bgc {
	0% {
		transform: rotateZ(0);
	}

	100% {
		transform: rotateZ(360deg);
	}
}

#face-live-detection-video {
	border-radius: 50%;
	background-color: transparent;
}

.tip {
	position: relative;
	margin-top: 20px;
	font-size: 20px;
	z-index: 10;
}

.tip.running {
	font-weight: bold;
	color: #fff;
}

.ui-camera {
	position: relative;
	z-index: 4;
}

.ui-camera-inner {
	width: 100%;
	height: 100%;
}

.ui-camera-video {
	position: absolute;
	left: 0;
	top: 0;
	z-index: 1;
	width: 100%;
	height: 100%;
	transform: rotateY(180deg);
	object-fit: cover;
	border-radius: 50%;
	background-color: #fff;
}

.center {
	position: relative;
	margin: 40px auto 0;
	border-radius: 50%;
}

.inner {
	position: relative;
	zoom: 1;
}

.loading {
	width: 100%;
	height: 220px;
	position: absolute;
	left: 0;
	top: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	background: rgba(255, 255, 255, 0.6);
	z-index: 5;
}

.circle1 {
	z-index: 1;
}

.circle2 {
	z-index: 2;
}

.circle3 {
	z-index: 3;
}

.circle {
	position: absolute;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	height: 100vh;
}

.dialog>>>.el-dialog__body {
	font-size: 16px;
	line-height: 30px;
}

.loading-image {
	width: 220px;
	height: 220px;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: 5;
}

/* TODO: ❗️❗️❗️添加降级方案---样式添加 */
.downgrade-text {
	margin-top: 40px;
	font-size: 18px;
	margin-bottom: 24px;
}

.downgrade-guide-wrapper {
	width: 273px;
	height: 253px;
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 0 auto 40px;
}

.downgrade-guide-correct-image {
	width: 178px;
	height: 100%;
	margin-right: 10px;
	border-radius: 6px;
}

.downgrade-guide-sub-wrapper {
	flex: 1;
	min-width: 0;
	display: flex;
	flex-direction: column;
}

.downgrade-guide-sub-image {
	width: 100%;
	border-radius: 6px;
}

.downgrade-guide-sub-image+.downgrade-guide-sub-image {
	margin-top: 10px;
}

.downgrade-tip-wrapper {
	font-size: 16px;
	font-weight: 400;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

.downgrade-tip {
	display: flex;
	align-items: center;
	line-height: 1;
	margin-bottom: 20px;
	min-width: 212px;
	max-width: 90%;
}

.downgrade-tip::before {
	content: '';
	display: inline-block;
	vertical-align: middle;
	width: 7px;
	height: 7px;
	border-radius: 50%;
	background-color: rgb(0, 48, 135);
	margin-right: 8px;
}
</style>
